<template>
	<article
		class="app-catalog-course"
		:class="{
			'app-catalog-course--finished': finished,
			'app-catalog-course--started': started,
			'app-catalog-course--full-version': full_only,
		}"
	>
		<div class="app-catalog-course__top">
			<button
				class="app-catalog-course__top-btn app-catalog-course__top-btn--preview"
				:data-course-id="course.id"
				data-url="/courses/"
				:data-started="started"
				@click.prevent="openPreviewPopup()"
				type="button"
			>
				<span>{{ $t('buttons.preview') }}</span>
				<svg aria-hidden="true" viewBox="0 0 24 19" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 20.5v-8h-8a.5.5 0 010-1h8v-8a.5.5 0 011 0v8h8a.5.5 0 010 1h-8v8a.5.5 0 01-1 0z"/></svg>
			</button>
			<button
				@click="wish ? rmWish() : addWish()"
				v-if="!full_only"
				class="app-catalog-course__top-btn app-catalog-course__top-btn--wish"
				:class="{ 'is-active': wish }"
				type="button"
			>
				<span>{{ $t('buttons.add_to_wishes') }}</span>
				<svg aria-hidden="true" viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.516 3.351a5.266 5.266 0 013.655 1.342l.32.285.319-.285a5.266 5.266 0 018.774 3.773 5.265 5.265 0 01-1.33 3.649l-7.766 7.777-7.765-7.777A5.266 5.266 0 017.516 3.35z"/></svg>
			</button>
		</div>
		<a
			:href="'/courses/' + course.id"
			class="app-catalog-course__image-link"
			:data-course-id="course.id"
			data-url="/courses/"
			:data-started="started"
		>
			<img
				:src="course.logo"
				:alt="course.id"
				class="app-catalog-course__image"
				loading="lazy"
			/>
		</a>
		<div class="app-catalog-course__content">
			<h3 class="app-catalog-course__title">
				<a
					:href="'/courses/' + course.id"
					ref="courseTitle"
					class="app-catalog-course__title-link"
				>
					{{ course.name }}
				</a>
			</h3>
			<div class="app-catalog-course__bottom">
				<p v-if="finished" class="app-catalog-course__text">
					{{ $t('deadlines.completed') }}
				</p>
				<p v-else-if="started" class="app-catalog-course__text">
					<a
						:href="'/courses/' + course.id"
						class="link-btn"
					>
						{{ $t('deadlines.continue') }}
					</a>
				</p>
				<p v-if="full_only" class="app-catalog-course__text">
					{{ $t('full_only') }}>
				</p>
				<ul class="app-catalog-course__list">
					<li v-if="!(full_only)">
						<div class="course-tag course-tag--sm course-tag--outline">{{ duration(course.duration_minutes) }}</div>
					</li>
					<li v-if="course.type" class="app-course-card__type">
						<div class="course-tag course-tag--sm course-tag--brend">{{ $t(`course_types.${course.type}`) }}</div>
					</li>
				</ul>
			</div>
		</div>
	</article>
</template>

<script>
import axios from "axios";

export default {
	name: "CoursePreview",

	props: {
		course: Object,
		full_only: {
			type: Boolean,
			default: true,
		},
		finished: {
			type: Boolean,
			default: false,
		},
		started: {
			type: Boolean,
			default: false,
		},
		bookmark: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			wish: this.bookmark,
		};
	},

	methods: {
		addWish() {
			axios
				.request({
					response_type: "json",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						"X-CSRF-Token": document
							.querySelector('meta[name="csrf-token"]')
							.getAttribute("content"),
					},
					method: "POST",
					url: "/wishes",
					data: { course_id: this.course.id },
				})
				.then((response) => {
					this.wish = true;
				})
				.catch((errors) => {
					console.log(errors.response.data);
				});
		},

		rmWish() {
			axios
				.request({
					response_type: "json",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						"X-CSRF-Token": document
							.querySelector('meta[name="csrf-token"]')
							.getAttribute("content"),
					},
					method: "DELETE",
					url: "/wishes/" + this.course.id,
					data: { course_id: this.course.id },
				})
				.then((response) => {
					this.wish = false;
				})
				.catch((errors) => {
					console.log(errors.response.data);
				});
		},

		limitSizeTitle() {
			let text = this.$refs.courseTitle.textContent.trim();

			if (text.length > 60) {
				this.$refs.courseTitle.textContent = text.slice(0, 60) + "...";
			}
		},

		duration(minutes) {
			if (minutes < 60) {
				return minutes + this.$t('duration.min');
			} else {
				return Math.round(minutes / 60) + this.$t('duration.h');
			}
		},

		openPreviewPopup() {
			axios
				.request({
					response_type: "json",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						"X-CSRF-Token": document
							.querySelector('meta[name="csrf-token"]')
							.getAttribute("content"),
					},
					methods: "GET",
					url: `/courses/${this.course.id}`,
				})
				.then((response) => {
					this.$store.commit("set_data_course_preview_popup", response.data);
					this.$store.commit("trigger_course_preview_popup", true);
				})
				.catch((errors) => {
					// nothing do this
				});
		},
	},
};
</script>
